import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Query } from 'react-apollo'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import SearchInput from '../../components/SearchInput/'
import InvoiceTable from '../../components/InvoiceTable/'
import EmployeeCTA from '../../components/EmployeeCTA/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { SELF_QUERY } from '../../queries'

import { Container } from '../../styles/defaults'
import { PageTitle, SearchContainer, InfoContainer, CompanyInfo, MiniContainer } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import employee from '../../assets/cta/employee.png'

class Invoices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      invoices: [],
      openInvoices: []
    }
  }

  // Sort invoices based on date
  componentDidMount() {
    const openInvoices = this.props.invoices.filter(invoice => invoice.type === 'O')
    const invoices = this.props.invoices.filter(invoice => invoice.type === 'B')
    this.setState({
      invoices: invoices.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate)),
      openInvoices: openInvoices.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate))
    })
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })
    this.setState({
      invoices: this.props.invoices
        .filter(invoice => {
          let invoiceDate = moment(invoice.invoiceDate).format('DD-MM-YYYY')
          let expirationDate = moment(invoice.expirationDate).format('DD-MM-YYYY')
          let invoiceNumber = invoice.invoiceNumber
            .toString()
            .toLowerCase()
            .slice(0, queryLength)
          let amount = invoice.amount
            .toString()
            .toLowerCase()
            .slice(0, queryLength)

          return (
            invoiceDate.includes(query) || expirationDate.includes(query) || invoiceNumber === query || amount === query
          )
        })
        .sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate))
    })
  }

  formatInvoices(invoices) {
    const items = []
    invoices.map(invoice => {
      let documents = invoice.documents.map(document => document.documentName)
      return items.push({
        id: invoice.id,
        one: invoice.invoiceNumber,
        two: moment(invoice.invoiceDate).format('DD-MM-YYYY'),
        three: moment(invoice.expirationDate).format('DD-MM-YYYY'),
        four: invoice.amount,
        five: documents,
        complaint: invoice.complaint,
        reminder: invoice.reminder
      })
    })

    return items
  }

  render() {
    const { invoices, openInvoices } = this.state
    const headers = ['Factuurnummer', 'Factuurdatum', 'Vervaldatum', 'Bedrag', 'Bijlagen']
    const formattedInvoices = this.formatInvoices(invoices)
    const formatOpenInvoices = this.formatInvoices(openInvoices)
    return (
      <Fragment>
        <Hero setsize='small' small={hero} medium={hero} large={hero} retina={hero} title='Facturen' />
        <Breadcrumb title='Facturen' />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from='25%' to='45%' fixed />
            if (error) return <Error error='de gebruikersgegevens' />
            const { self } = data
            let viewInvoices = self.permissions.includes('VIEW_INVOICES') || self.role === 'MANAGER'

            return (
              <Fragment>
                {viewInvoices ? (
                  <Fragment>
                    {openInvoices.length > 0 ? (
                      <Fragment>
                        <Container mt>
                          <PageTitle>Openstaande facturen</PageTitle>
                        </Container>
                        <Container mt mb>
                          <InvoiceTable
                            headers={headers}
                            items={formatOpenInvoices}
                            data={data}
                            loading={loading}
                            error={error}
                          />
                        </Container>
                        <Container mt>&nbsp;</Container>
                      </Fragment>
                    ) : null}
                    <Container mt>
                      <PageTitle>Factuurhistorie</PageTitle>
                    </Container>
                    <InfoContainer full>
                      <CompanyInfo>{this.state.invoices.length} facturen</CompanyInfo>
                      <SearchContainer>
                        <SearchInput placeholder='Zoeken' onSearch={this.onSearch.bind(this)} />
                      </SearchContainer>
                    </InfoContainer>
                    <Container mt mb>
                      {invoices.length > 0 ? (
                        <Fragment>
                          <InvoiceTable
                            headers={headers}
                            items={formattedInvoices}
                            data={data}
                            loading={loading}
                            error={error}
                          />
                          <MiniContainer full>
                            <EmployeeCTA
                              size={'medium'}
                              content={{
                                title: 'Vragen over een factuur?',
                                subtitle: 'We helpen u graag',
                                employee: true,
                                image: employee,
                                link: {
                                  content: 'Contact',
                                  url: '/contact',
                                  target: ''
                                }
                              }}
                            />
                          </MiniContainer>
                        </Fragment>
                      ) : (
                        <Fragment>Er zijn geen facturen beschikbaar</Fragment>
                      )}
                    </Container>
                  </Fragment>
                ) : (
                  <Container mt mb>
                    Onvoldoende rechten om de facturen te bekijken
                  </Container>
                )}
              </Fragment>
            )
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Invoices)



// WEBPACK FOOTER //
// ./src/views/Invoices/index.js